import { render } from "./UserComments.vue?vue&type=template&id=745b15e5&scoped=true"
import script from "./UserComments.vue?vue&type=script&lang=js"
export * from "./UserComments.vue?vue&type=script&lang=js"

import "./UserComments.vue?vue&type=style&index=0&id=745b15e5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745b15e5"]])

export default __exports__